import {createSlice} from '@reduxjs/toolkit'
import AutomationService from '../../api/automation'
import {toast} from 'react-toastify'
import FormHelper from '../../utils/forms'
import {routes} from '../../routes'
import NavigationHelper from '../../utils/navigation'

export const automationSlice = createSlice({
    name: 'automation',
    initialState: {
        automations: {},
        events: [],
        isFetching: false,
        isDeleting: false,
        checkedData: [],
        token: '',
        workflowId: ''
    },
    reducers: {
        setAutomations: (state,
            {payload}) => {
            state.automations = payload
        },
        setEvents: (state, {payload}) => {
            state.events = payload
        },
        setIsFetching: (state, {payload}) => {
            state.isFetching = payload
        },
        setToken: (state, {payload}) => {
            state.token = payload
        },
        setWorkflowId: (state, {payload}) => {
            state.workflowId = payload
        },
        setIsDeleting: (state) => {
            state.isDeleting = !state.isDeleting
        },
        setCheckedData: (state, {payload}) => {
            state.checkedData = payload
        },
        deleteAutomationFromArray: (state) => {
            let newAutomations = state.automations.data.automations?.filter(item => !state.checkedData.includes(item?.id))
            state.automations.data.automations = newAutomations
            state.checkedData = []
        }
    }
})

export const {
    setAutomations,
    setEvents,
    setIsFetching,
    setIsDeleting,
    setCheckedData,
    deleteAutomationFromArray, setToken, setWorkflowId
} = automationSlice.actions

export default automationSlice.reducer

export const getAutomations = (showLoader = true) => {
    return async dispatch => {
        showLoader && dispatch(setIsFetching(true))
        try {
            const {data} = await AutomationService.getAutomations()
            dispatch(setAutomations(data))
        } catch (e) {
            toast.error(e?.response?.data?.message)
        }
        showLoader && dispatch(setIsFetching(false))
    }
}

export const getEvents = () => {
    return async dispatch => {
        try {
            const {data} = await AutomationService.getEvents()
            dispatch(setEvents(data?.data?.events))
        } catch (e) {
            toast.error(e?.response?.data?.message)
        }
    }
}

export const createAutomation = (data, setFieldError) => {
    return async() => {
        try {
            const session = await AutomationService.createAutomation(data)
            toast.success(session?.data.message)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message, setFieldError)
        }
    }
}

export const updateAutomation = (id, data, setFieldError) => {
    return async() => {
        try {
            const session = await AutomationService.updateAutomation(id, data)
            toast.success(session?.data.message)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message, setFieldError)
        }
    }
}

export const deleteAutomation = id => {
    return async dispatch => {
        dispatch(setIsDeleting())
        try {
            const {data} = await AutomationService.deleteAutomation(id)
            dispatch(deleteAutomationFromArray())
            toast.success(data?.message)
            dispatch(getAutomations())
            dispatch(setIsDeleting())
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message)
        }
        dispatch(setIsDeleting())
    }
}

export const getTokenAndWorkflowId = (id, navigate) => {
    return async dispatch => {
        try {
            const [tokenData, workflowIdData] = await Promise.all([
                AutomationService.getToken(id),
                AutomationService.getWorkflowId(id)
            ])
            dispatch(setToken(tokenData?.data?.data?.token))
            dispatch(setWorkflowId(workflowIdData?.data?.data?.automation?.workflow_id))
        } catch (e) {
            navigate(NavigationHelper.getLocalizedPath(routes.not_found.paths))
        }
    }
}
